"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _connect = require("./connect");
Object.keys(_connect).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _connect[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _connect[key];
    }
  });
});